import $ from 'jquery';
/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap($el) {

  // Find marker elements within map.
  var $markers = $el.find('.map__marker');
  // Create gerenic map.
  var mapArgs = {
    zoom: 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    styles: [
        {
          "featureType": "all",
          "elementType": "geometry",
          "stylers": [
            { "gamma": 0.82 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "geometry.fill",
          "stylers": [
            { "gamma": 1.21 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "labels",
          "stylers": [
            { "lightness": -60 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "labels.text",
          "stylers": [
            { "gamma": 5.37 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            { "color": "#419d8c" },
            { "lightness": -39 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            { "visibility": "on" },
            { "color": "#ffffff" },
            { "lightness": 16 },
          ],
        },
        {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [
            { "visibility": "off" },
          ],
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            { "color": "#fefefe" },
            { "lightness": 20 },
          ],
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            { "color": "#fefefe" },
            { "lightness": 17 },
            { "weight": 1.2 },
          ],
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            { "color": "#f5f5f5" },
            { "lightness": 20 },
          ],
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry.fill",
          "stylers": [
            { "saturation": 0 },
          ],
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            { "color": "#f5f5f5" },
            { "lightness": 21 },
          ],
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            { "color": "#dedede" },
            { "lightness": 21 },
          ],
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            { "color": "#ffffff" },
            { "lightness": 17 },
          ],
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            { "color": "#ffffff" },
            { "lightness": 29 },
            { "weight": 0.2 },
          ],
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            { "color": "#ffffff" },
            { "lightness": 18 },
          ],
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            { "color": "#ffffff" },
            { "lightness": 16 },
          ],
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            { "color": "#f2f2f2" },
            { "lightness": 19 },
          ],
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            { "color": "#e9e9e9" },
            { "lightness": 17 },
          ],
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            { "color": "#42738d" },
            { "gamma": 5.37 },
          ],
        },
      ],
          
  };
  var map = new google.maps.Map($el[0], mapArgs);

  // Add markers.
  map.markers = [];
  $markers.each(function () {
    initMarker($(this), map);
  });


  // Center map based on markers.
  centerMap(map);

  // Return map instance.
  return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker($marker, map) {
  var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

  // Get image for mapMarker
  const icon = "../wp-content/themes/covantis3/resources/img/marker.svg";

  console.log(icon)

  // Create marker instance.
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: icon,
  });

  // Append to reference for later use.
  map.markers.push(marker);
}


/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap(map) {

  // Create map boundaries from all map markers.
  var bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function (marker) {
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng(),
    });
  });

  // Case: Single marker.
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());

    // Case: Multiple markers.
  } else {
    // map.fitBounds( bounds );
    map.setCenter(bounds.getCenter());
  }
}

// Render maps on page load.
$(window).on('load', function () {
  setTimeout(function() {
    $('.js-map').each(function () {
      var map = initMap($(this));
      return map
    });
  }, 500)
});
